<template>
  <div style="max-height: 200px;overflow: auto;">
    <draggable
      style="display: inline-block;"
      @start="disabled = true"
      @end="disabled = false"
      :list="value">
      <span
        class="question-number"
        v-for="(question, index) in value"
        v-if="!fixedIds.includes(question.id)"
        @click="scrollIntoView(index)">
          <el-tooltip :disabled="disabled"
                      effect="dark"
                      :content="(question.title || '未填写标题') | stripTags"
                      placement="top"
                      :enterable="false">
            <el-tag
              size="small"
              effect="dark"
              :type="dangerIds.includes(question.id) ? 'danger' : 'info'">
                <span>{{index+1}}</span>
            </el-tag>
          </el-tooltip>
      </span>
    </draggable>
    <span
      class="question-number"
      v-for="(question, index) in value"
      v-if="fixedIds.includes(question.id)"
      @click="scrollIntoView(index)">
          <el-tooltip effect="dark"
                      :content="(question.title || '未填写标题') | stripTags"
                      placement="top">
            <el-tag
              size="small"
              effect="dark"
              :type="dangerIds.includes(question.id) ? 'danger' : 'info'">
                <span>{{index+1}}</span>
            </el-tag>
          </el-tooltip>
      </span>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {draggable},
  inheritAttrs: false,
  props: {
    value: Array,
    questionItems: Array,
    dangerIds: Array,
    fixedIds: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      disabled: false
    }
  },
  watch: {},
  created () {},
  mounted () {},
  updated () {},
  destroyed () {},
  methods: {
    scrollIntoView (index) {
      this.questionItems[index].scrollIntoView()
    },
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.question-number {
  display: inline-block;
  margin-right: 5px;
  margin-bottom: 10px;

  .el-tag {
    position: relative;
    min-width: 28px;
    text-align: center;
    padding: 0 4px;
    cursor: pointer;

    &:hover {
      opacity: .8;
    }

    &.el-tag--info {
      background-color: #f4f4f5;
      border-color: #e9e9eb;
      color: #606266;
    }
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/packages/sj-question-number/src/SjQuestionNumber.vue